<template>
  <SidebarComponent>

    <SortingComponent/>

    <MultipleSelectionComponent/>

    <SlidableComponent
      name="dd-email-slider"
      :leftComponent="CompactInboxListComponent"
      :rightComponent="ViewComponent"
      :leftComponentMinWidth="290"
      :leftComponentMaxWidth="550"
    />

    <MatchModalComponent/>

  </SidebarComponent>

</template>

<script>
import SlidableComponent from "~/pages/components/SlidableComponent.vue";
import ViewComponent from "../components/ViewComponent.vue";
import SidebarComponent from "../components/SidebarComponent.vue";
import CompactInboxListComponent from "../components/CompactInboxListComponent.vue";
import SortingComponent from "../components/SortingComponent.vue";
import MatchModalComponent from "../components/match/MatchModalComponent.vue";
import MultipleSelectionComponent from "../components/MultipleSelectionComponent.vue";

export default {
  name: "ViewPage.vue",
  components: {
    SidebarComponent,
    SlidableComponent,
    SortingComponent,
    MultipleSelectionComponent,
    MatchModalComponent
  },
  computed: {
    ViewComponent() {
      return ViewComponent;
    },
    CompactInboxListComponent() {
      return CompactInboxListComponent;
    }
  },
}

</script>

<style lang="scss" scoped>
#inbox-page > *{
  &:nth-child(1){
    flex: 0.15;
    min-width: 270px;
  }
  &:nth-child(2){
    flex: 0.85;
  }
}
</style>
